module.exports = __webpack_public_path__ + "img/20201204_115027.dee7eaf3.jpg";